export default "__VITE_ASSET__CFiCxO0W__"